/* eslint-disable no-console */
import './alert.css';

import Icon from '@icons';
import Button from '@material-ui/core/Button';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

const ModalBox = styled.div`
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  padding: 40px;
  box-sizing: border-box;
  outline: 0;
  padding-top: 20px;
  /* padding-bottom: 90px; */
  padding-bottom: 30px;
  min-width: 250px;
  max-width: 80vw;

  header {
    border-bottom: 1px solid #e6e6e6;

    h2 {
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 41px;
    }
  }

  footer {    
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: end;
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    margin-top: 27px;
    color: #5e6366;
    white-space: normal;
    /* word-break: break-all; */
    word-break: break-word;
  }

  .close {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
`;

/**
 * Estilização do componente StyledButton
 */
const StyledButton = styled(Button)`
  &.MuiButton-root {
    text-transform: none;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 20px;
    min-width: 104px;
  }

  &.MuiButton-contained {
    box-shadow: none;
  }

  &.MuiButton-containedPrimary {
    color: #fff;
    background-color: #3c71dd;
    top: 10px;
  }
`;
/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
const onClose = () => {
  ReactDOM.render(null, document.getElementById('alert'));
};

/**
 * Alert é um substituto do window.alert() nativo do javascript com
 * a diferença de que esse está estilizado em um modal com a identidade
 * visual do projeto. Apenas um alert por vez pode ser disparado e ele
 * pode ter um callback ao confirmar.
 * Também é possível disponibilizar a opção 'Não mostre novamente' para o 
 * usuário com um timer de reexibição predefinido.
 */
export const Alert = ({ title, message, callback, buttonText }) => {

  const closeAndCallback = () => {
    if (callback && typeof callback === 'function') {
      callback();
    }
    onClose();
  };

  const confirmAlert = () => {
    closeAndCallback();
  };

  /**
   * Estrutura do componente Alert modal com
   * identidade visual do projeto
   */
  return (
    <div className="modalAlert" style={{ zIndex: 2000 }}>
        <ModalBox>
          <button onClick={closeAndCallback} className="close">
            <Icon i="all-close" />
          </button>
          <header>
            <h2>{title || 'GEOBAHIA informa:'}</h2>
          </header>
          <div className="content">{message && <p>{message}</p>}</div>
          <footer>
            <StyledButton            
              variant="contained"
              color="primary"
              onClick={confirmAlert}
            >
              {buttonText || 'OK'}
            </StyledButton>
          </footer>
        </ModalBox>
    </div>
    );
};

Alert.propTypes = {
  /** Titulo do Alerta */
  title: PropTypes.string,
  /** Mensagem do Alerta */
  message: PropTypes.string.isRequired,
  /** Função de callback */
  callback: PropTypes.func,
  /** Texto do botão do Alerta */
  buttonText: PropTypes.string,
};

export default Alert;
